import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6c6347cc"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container flex-col-ter" }
const _hoisted_2 = { class: "title" }
const _hoisted_3 = { class: "description" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "note" }, "※なお、会員ランクをアップグレードした場合、エコノミープランへの戻しはできませんのでご注意ください。", -1))
const _hoisted_5 = { class: "flex-aiend operate" }

import { ref, computed } from 'vue'
import { t } from '@/plugins/i18n'
import MemberCard from './MemberCard.vue'
import { MembershipTemplatePriceListVO } from '@/service/settlement'

export default /*#__PURE__*/_defineComponent({
  props: {
    comboList: { type: Array, required: true }
  },
  emits: ['ok', 'cancel'],
  setup(__props: any, { expose, emit: emits }) {

const props = __props as {
  comboList: MembershipTemplatePriceListVO[],
}


const visible = ref(false)

const standardVip = computed(() => {
  return {
    level: 2,
    name: '',
    recommonBuy: t('参考购买金额：30万～100万日元/月'),
    fee: 0,
    logo: 'https://static-s.theckb.com/BusinessMarket/Client/member/member_level_2.png',
    desc: [
      {
        title: t('EC 网站商品采购')
      }, {
        title: t('类似图片搜索')
      }, {
        title: t('日本标准质检')
      }, {
        title: t('品牌代理销售权')
      }, {
        title: t('与日本 EC 网站系统联动和代发货服务')
      }, {
        title: t('自定义选项和材料使用')
      }, {
        title: t('简单 OEM 支持')
      }, {
        title: t('系统聊天和 LINE 专属支持')
      }
    ],
    combo: props.comboList.find(i => i.templateLevel === 2) ?? {}
  }
})

const show = () => {
  visible.value = true
}

const cancel = () => {
  visible.value = false
  emits('cancel')
}

const ok = () => {
  visible.value = false
  emits('ok')
}

expose({ show })


return (_ctx: any,_cache: any) => {
  const _component_ElButton = _resolveComponent("ElButton")!
  const _component_ElSpace = _resolveComponent("ElSpace")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createBlock(_component_el_dialog, {
    "model-value": visible.value,
    "show-close": false,
    width: "700px",
    top: "10vh",
    "destroy-on-close": "",
    "custom-class": "UpTipsDialog"
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, _toDisplayString(_unref(t)('会员体系变动提示')), 1),
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", null, _toDisplayString(_unref(t)('尊敬的用户，我们针对会员体系进行了一系列优化。从今天起1980円经济仓不再对外开通。鉴于您是THE CKB的资深用户，您仍然可以进行使用和续费。')), 1),
          _createElementVNode("div", null, _toDisplayString(_unref(t)('最后，若您的每月采购额在30万-100万日元之间，我们推荐您升级标准仓，权益更丰富，首月只需0円（原价9800円/月）！')), 1),
          _hoisted_4
        ]),
        _createVNode(MemberCard, {
          class: "card",
          memberCardInfo: _unref(standardVip)
        }, null, 8, ["memberCardInfo"]),
        _createElementVNode("div", _hoisted_5, [
          _createVNode(_component_ElSpace, null, {
            default: _withCtx(() => [
              _createVNode(_component_ElButton, {
                size: "large",
                round: "",
                onClick: cancel
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_unref(t)('暂不开通')), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_ElButton, {
                size: "large",
                round: "",
                color: "#000",
                style: {"color":"#fff"},
                onClick: ok
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_unref(t)('立即0元升舱')), 1)
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ])
      ])
    ]),
    _: 1
  }, 8, ["model-value"]))
}
}

})